import { z } from "zod";

import { enterpriseSchema } from "../commons";

export const getEnterpriseParamsSchema = z.object({
  enterpriseSlug: z.string().nonempty(),
});

export const getEnterpriseRequestSchema = z.object({
  params: getEnterpriseParamsSchema,
});

export type GetEnterpriseRequest = z.infer<typeof getEnterpriseRequestSchema>;

export const getEnterpriseResponseSchema = enterpriseSchema;

export type GetEnterpriseResponse = z.infer<typeof getEnterpriseResponseSchema>;
